import {
  AgendaItemProvider,
  AgendaItemTypesProvider,
  ApiProvider,
  AppBannerProvider,
  BoardProvider,
  BoardSettingsProvider,
  DocumentProvider,
  DocumentsPanelProvider,
  EdecidePanelProvider,
  EnumChoicesProvider,
  LayoutProvider,
  MeetingProvider,
  MeetingsProvider,
  ParamsProvider,
  ParticipantProvider,
  PasteDialogProvider,
  PermissionsProvider,
  SendToPanelProvider,
  StandardMeetingsPanelProvider,
  TaskProvider,
  TaskViewsProvider,
} from "providers";
import { FC, PropsWithChildren, ReactNode } from "react";

const providerStack: FC<PropsWithChildren>[] = [
  AppBannerProvider,
  ApiProvider,
  PasteDialogProvider,
  PermissionsProvider,
  EnumChoicesProvider,
  AgendaItemTypesProvider,
  TaskViewsProvider,
  ParamsProvider,
  BoardProvider,
  BoardSettingsProvider,
  MeetingProvider,
  MeetingsProvider,
  DocumentProvider,
  AgendaItemProvider,
  ParticipantProvider,
  TaskProvider,
  DocumentsPanelProvider,
  EdecidePanelProvider,
  SendToPanelProvider,
  StandardMeetingsPanelProvider,
  LayoutProvider,
];

export const AppProviders: FC<PropsWithChildren<unknown>> = ({ children }) => {
  return providerStack.reduceRight<ReactNode>((acc, Provider) => <Provider>{acc}</Provider>, children);
};
